import { api } from '../core';
import { PageUpdate } from './types';

export interface MarkBreachRequest {
  pageIds: string[];
}

// Response is directly an array of PageUpdate objects
export type MarkBreachResponse = PageUpdate[];

export interface MarkBreachProps {
  abortController?: AbortController;
  pageIds: string[];
  documentId?: string;
}

const markBreachApi = api.injectEndpoints({
  endpoints: (builder) => ({
    markBreach: builder.mutation<MarkBreachResponse, MarkBreachProps>({
      query: ({ abortController = new AbortController(), pageIds }: MarkBreachProps) => ({
        url: 'gdpr/mark/breach',
        method: 'POST',
        signal: abortController.signal,
        body: {
          pageIds
        }
      }),

      extraOptions: { maxRetries: 3 }
    })
  })
});

export const { useMarkBreachMutation } = markBreachApi;
